import { motion, AnimatePresence } from 'framer-motion';
import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppContext from '../AppContext';
import { setUserId } from '../widgetSlice';
import { Header } from './Header';
import { Keypad } from './Keypad';
import { Messages } from './Messages';
import { useParams } from 'react-router-dom';
import ChatList from './ChatList';
import { Empty } from 'antd';
export const WidgetLayout = (props) => {
  const dispatch = useDispatch();
  let { toggleWidget, userId: _userId } = useSelector(
    (state) => state.widgetState
  );
  let { userId, embedded } = props;
  let userIdRef = useRef(_userId);
  const { id } = useParams();
  useEffect(() => {
    if (userId) {
      userIdRef.current = userId;
    } else {
      if (!userIdRef.current) {
        userIdRef.current = nanoid();
        dispatch(setUserId(userIdRef.current));
      }
    }
  }, [dispatch, embedded, props.userId, toggleWidget, userId]);

  return (
    <AppContext.Provider value={{ userId: userIdRef.current, ...props }}>
      <AnimatePresence>
        <div className="flex h-full w-full">
          <div className="bg-white m-2 w-[420px] drop-shadow-md h-[80vh]">
            <ChatList />
          </div>
          <div className="w-full h-full">
            {id ? (
              <motion.div
                className="font-lato  flex flex-col bg-white font-sans rounded-b-[16px] h-full "
                key="widget"
              >
                <Header />
                <Messages />
                <Keypad />
              </motion.div>
            ) : (
              <Empty className="mt-16" description={false} />
            )}
          </div>
        </div>
      </AnimatePresence>
    </AppContext.Provider>
  );
};
